import React from "react";
import Box from "components/common/Box";
import Stack from "components/common/Stack";

const OPTIONS = [
  { key: "phone", label: "Phone Number" },
  { key: "email", label: "Email" },
];

/**
 * Segmented Phone / Email toggle matching Figma login design.
 */
const AuthModeToggle = ({ value = "phone", onChange }) => {
  return (
    <Stack
      direction="row"
      sx={{
        width: "100%",
        mb: 3,
        p: "4px",
        bgcolor: "#F2F4F7",
        borderRadius: "10px",
        boxSizing: "border-box",
      }}
    >
      {OPTIONS.map(({ key, label }) => {
        const active = value === key;
        return (
          <Box
            key={key}
            component="button"
            type="button"
            onClick={() => onChange?.(key)}
            sx={{
              flex: 1,
              border: "none",
              cursor: "pointer",
              fontFamily: "inherit",
              fontSize: "14px",
              fontWeight: 500,
              lineHeight: 1.2,
              py: 1.25,
              px: 1,
              borderRadius: "8px",
              textAlign: "center",
              transition: "all 0.15s ease",
              bgcolor: active ? "#FFFFFF" : "transparent",
              color: active ? "#2977ec" : "#667085",
              boxShadow: active
                ? "0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)"
                : "none",
              "&:hover": {
                color: active ? "#2977ec" : "#344054",
              },
            }}
          >
            {label}
          </Box>
        );
      })}
    </Stack>
  );
};

export default AuthModeToggle;
